import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';

import {
  defaultRejectHandler,
  stringifyErrorMessage,
} from '../../utils/utility';

import {
  addAirHandlingUnitToZone,
  editAirHandlingUnitInZone,
  listAirHandlingUnitInZone,
  removeAirHandlingUnitFromZone,
} from '../../redux/zone/zone_ahu_actions';
import { searchACCentralAirHandlingUnitByText } from '../../redux/ac_central/ac_central_actions';


export class AirHandlingUnitDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isDuplicateModal: false,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listAhu(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  render() {
    const { categoryOption } = this.state;

    const {
      zoneId,
      ahuList,
      filteredCount,
      isLoading,
      addAhuToZone,
      editAhuInZone,
      removeAhuFromZone,
      isAhuAdding,
      isAhuEditing,
      isAhuRemoving,
      errorMessage,
      t,
    } = this.props;

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    const columns = [
      {
        Header: '',
        accessor: 'air_conditioning_central_fan_coil.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'air_conditioning_central_fan_coil.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchACCentralAirHandlingUnitByText(text, page, zoneId)
            .then(response => response.data.map(({ac_central_name, fan_coil_name, id}) =>
              ({label: `${fan_coil_name} - ${ac_central_name}`, value: String(id)}))),
        },
      },
      {
        Header: () => <b>{t('type')}</b>,
        accessor: 'air_conditioning_central_fan_coil.type',
        ...textColumn,
        width: 120,
      },
      {
        id: 'coolingCapacity',
        Header: () => <b>{t('cooling capacity')}</b>,
        accessor: row => `${row.air_conditioning_central_fan_coil.cooling_capacity} ${row.air_conditioning_central_fan_coil.unit}`,
        ...coeColumn,
        width: 160,
      },
      {
        Header: () => <b>{t('power (kW)')}</b>,
        accessor: 'air_conditioning_central_fan_coil.power_required',
        ...coeColumn,
        width: 200,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...textColumn,
        width: 80,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    const relationship = {
      create: ({ entityId, quantity }) => addAhuToZone(entityId, quantity),
      edit: ({ id, quantity }) => editAhuInZone(id, quantity),
      delete: id => removeAhuFromZone(id),
      isCreating: isAhuAdding,
      isEditing: isAhuEditing,
      isDeleting: isAhuRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={columns}
          data={ahuList}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.air_conditioning_central_fan_coil.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ahuList: state.zoneAhu.orderedIds.map(id => state.zoneAhu.objects[id]),
  isLoading: state.zoneAhu.isLoading,
  isAhuAdding: state.zoneAhu.isCreating,
  isAhuEditing: state.zoneAhu.isEditing,
  isAhuRemoving: state.zoneAhu.isDeleting,
  errorMessage: state.zoneAhu.errorMessage,
});

const mapDispatchToProps = (dispatch, ownedProps) => ({
  listAhu: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listAirHandlingUnitInZone(pageSize, page, sorted, filtered, isPublic, ownedProps.zoneId))),
  addAhuToZone: (ahuId, quantity) =>
    defaultRejectHandler(dispatch(addAirHandlingUnitToZone(ahuId, ownedProps.zoneId, quantity))),
  editAhuInZone: (id, quantity) =>
    defaultRejectHandler(dispatch(editAirHandlingUnitInZone(id, quantity))),
  removeAhuFromZone: id =>
    defaultRejectHandler(dispatch(removeAirHandlingUnitFromZone(id))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(AirHandlingUnitDataTable),
);



// WEBPACK FOOTER //
// ./src/components/zone/AirHandlingUnitDataTable.js